import qrcode from "qrcode-generator";
import type { Ecc } from "./capacity";
import { detectMode } from "./style";

// Byte mode must use UTF-8 to match the renderer (qr-code-styling sets UTF-8 on its own copy).
// qrcode-generator 2.x defaults to a legacy one-byte-per-char mapping, so replace it.
qrcode.stringToBytes = (s: string): number[] => Array.from(new TextEncoder().encode(s));

export interface SymbolInfo {
	version: number;
	modules: number;
}

/**
 * Encode without drawing, to report version and module count. Uses the same encoder
 * family and mode selection as the renderer. Throws if the data does not fit.
 */
export function describeSymbol(text: string, ecc: Ecc): SymbolInfo {
	const qr = qrcode(0, ecc);
	qr.addData(text, detectMode(text));
	qr.make();
	const modules = qr.getModuleCount();
	return { version: (modules - 17) / 4, modules };
}

/** Turn an encoder error into a sentence a user can act on. */
export function friendlyError(err: unknown): string {
	const msg = err instanceof Error ? err.message : String(err);
	if (/too big|too long|overflow/i.test(msg)) {
		return "That is too much data for a QR code at this error correction level. Shorten the text or choose a lower level.";
	}
	return `Could not generate the QR code (${msg}).`;
}
